import React from 'react'
import { useSelector } from 'react-redux';
import "./loading.css";

export default function Loading() {

    const {show} = useSelector(state => state.LoadingReducer);

    return (
        <div className="loading" style={show ? {display:'flex'} : {display: 'none'}}>
            <img src={require('../../assets/loading.svg').default} alt="loading" />
        </div>
    )
}
